import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { TipoEspacioProvider } from './Components/context/FiltroTipoEspacioContext';
import { CategoriaServicio} from './Components/context/FiltroCategoriaServicioContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TipoEspacioProvider>
        <CategoriaServicio> {/* ⬅️ Mueve aquí el Provider */}
          <App /> {/* Este contiene Navbar, ServiciosMain, etc. */}
        </CategoriaServicio>
      </TipoEspacioProvider>
    </BrowserRouter>
  </React.StrictMode>
);



reportWebVitals();
